module.exports = __webpack_public_path__ + "img/megafon.4e38e066.png";